import type { ProductVariation } from "@/lib/products-info";

export interface ProxyTier {
  proxies: number;
  monthlyPP: number;
  totalPrice: number;
  productId?: string;
  variationId?: string;
}

// Fallback used when the live products API is unavailable.
export const FALLBACK_PROXY_TIERS: ProxyTier[] = [
  { proxies: 1, monthlyPP: 59, totalPrice: 59 },
  { proxies: 2, monthlyPP: 59, totalPrice: 118 },
  { proxies: 5, monthlyPP: 59, totalPrice: 295 },
  { proxies: 10, monthlyPP: 59, totalPrice: 590 },
  { proxies: 20, monthlyPP: 59, totalPrice: 1180 },
  { proxies: 50, monthlyPP: 59, totalPrice: 2950 },
  { proxies: 100, monthlyPP: 59, totalPrice: 5900 },
];

export function buildProxyTiers(raw: ProductVariation[], fallback: ProxyTier[]): ProxyTier[] {
  if (!raw.length) return fallback;
  return raw
    .map((t) => {
      const total = parseFloat(t.price);
      return {
        proxies: t.value,
        monthlyPP: Math.round((total / t.value) * 100) / 100,
        totalPrice: total,
        productId: t.product_id,
        variationId: t.variation_id,
      };
    })
    .sort((a, b) => a.proxies - b.proxies);
}

export const PER_PROXY_FEATURES = [
  "Premium mobile IPs",
  "HTTP and SOCKS5 credentials",
  "Username/password or IP whitelist auth",
  "Public IPv4, speed, and usage per proxy",
  "Preferred location and ISP per proxy",
  "Manual and bulk IP rotation",
  "Rotation URL and interval controls",
  "Pooling with random or sticky behavior",
];
